import axiosClient from '../axiosClient';

const productAPI = {
    // async getListProductAPI(params) {
    //     const url = `/product`;
    //     const resp = await axiosClient.get(url, { params });
    //     return resp;
    // },

    async getListProductAPI(params) {
        const url = `/product/search_product`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },

    async getOneProductAPI(id, params) {
        const url = `/product/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getHotDealProductAPI(params) {
        const url = `/product`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getListProductForYouAPI(params) {
        const url = `/product/randomItem`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
};

export default productAPI;
